import React from 'react';
import {NotificationLink, NotificationText, NotificationWrapper} from './AccountNotification.style';
import contactUsModalEvents from '../../common/events/contactUsModal.events';
import {isSpecialTranslationCulture} from "../../common/services/translations.service";
import {FormType} from "../../contactUs/data/constants";

interface IAccountBaseBannerProps {
    contactUsText: string;
    startText: string;
    linkText: string;
    endText: string;
}

const AccountBaseBanner = (props: IAccountBaseBannerProps) => {
    const { contactUsText, startText, linkText, endText } = props;

    const onClick = () =>
        contactUsModalEvents.showContactUsModal(FormType.CUSTOM, {
            selectedCategoryId: 'option1',
            helpDescription: contactUsText,
        });

    return (
        <NotificationWrapper breakLine={isSpecialTranslationCulture()}>
            <NotificationText>{startText}</NotificationText>
            <NotificationLink onClick={onClick}>
                {linkText}
            </NotificationLink>
            <NotificationText>{endText}</NotificationText>
        </NotificationWrapper>
    );
};

export default AccountBaseBanner;
